import styled from 'styled-components';
import { themeSize } from '../../../theme/getters';
import { H2, spacedHeading } from '../../../theme/typography';

export const Container = styled.section`
  width: 100%;
  max-width: 745px;
  padding-left: ${themeSize('contentPadding')}px;
  padding-right: ${themeSize('contentPadding')}px;
  margin-left: auto;
  margin-right: auto;
`;

export const Title = styled(H2)`
  ${spacedHeading};
  margin-bottom: ${themeSize('contentVerticalMargin')}px;
`;
